import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconComputerUse: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconComputerUse"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM7.76562 8.08789L10.9844 16.6709L12.6895 12.6895L16.6709 10.9844L8.08789 7.76562L7.57324 7.57324L7.76562 8.08789Z" fill="currentColor"/></CentralIconBase>;
});

export default IconComputerUse;
